import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { RemoteAnalyticsRepo } from '@repository/analytics/AnalyticsRepo';
import AnalyticsJFThreeLogRq, { IAnalyticsJFThreeLogRq } from '@domain/rq/analytics/AnalyticsJFThreeLogRq';

const remoteAnalyticsRepo = new RemoteAnalyticsRepo();

const fetchAnalyticsJFThreeLogin = async (vo: IAnalyticsJFThreeLogRq) => {
  const rq = new AnalyticsJFThreeLogRq(vo);
  const { data } = await remoteAnalyticsRepo.fetchAnalyticsJFThreeLogin(rq);
  return data.result;
};

// useMutation ///
export function useAnalyticsJFThreeLogin(onSuccess?: () => void) {
  return useMutation((vo: IAnalyticsJFThreeLogRq) => fetchAnalyticsJFThreeLogin(vo), {
    onSuccess,
    onError: (error: AxiosError) => {
      console.log(error.response?.data);
      return;
    },
  });
}
